// extracted by mini-css-extract-plugin
module.exports = {"CancelButtonWrapper":"DealCancelButton_CancelButtonWrapper__M5QcZ","CancelButton":"DealCancelButton_CancelButton__2eOEz"};